const revealSelector = '[data-rare-reveal]:not([data-rare-reveal-ready])';

function setupRareReveals(root = document) {
  const elements = root.querySelectorAll(revealSelector);
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    elements.forEach((element) => {
      element.dataset.rareRevealReady = 'true';
      element.classList.add('is-visible');
    });
    return;
  }

  document.documentElement.classList.add('rare-motion-ready');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  elements.forEach((element) => {
    element.dataset.rareRevealReady = 'true';
    observer.observe(element);
  });
}

class RareCategoryRail extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-rare-rail-viewport]');
    this.previous = this.querySelector('[data-rare-rail-previous]');
    this.next = this.querySelector('[data-rare-rail-next]');

    if (!this.viewport || !this.previous || !this.next) return;

    this.handlePrevious = () => this.scrollByPage(-1);
    this.handleNext = () => this.scrollByPage(1);
    this.updateControls = () => this.syncControls();

    this.previous.addEventListener('click', this.handlePrevious);
    this.next.addEventListener('click', this.handleNext);
    this.viewport.addEventListener('scroll', this.updateControls, { passive: true });
    this.resizeObserver = new ResizeObserver(this.updateControls);
    this.resizeObserver.observe(this.viewport);
    this.syncControls();
  }

  disconnectedCallback() {
    if (!this.viewport) return;
    this.previous?.removeEventListener('click', this.handlePrevious);
    this.next?.removeEventListener('click', this.handleNext);
    this.viewport.removeEventListener('scroll', this.updateControls);
    this.resizeObserver?.disconnect();
  }

  scrollByPage(direction) {
    const card = this.viewport.querySelector('.rare-category-card');
    const distance = card ? card.getBoundingClientRect().width + 14 : this.viewport.clientWidth * 0.85;
    this.viewport.scrollBy({
      left: distance * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  syncControls() {
    const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    const current = Math.abs(this.viewport.scrollLeft);
    const hasOverflow = maximum > 3;

    this.querySelector('[data-rare-rail-controls]')?.toggleAttribute('hidden', !hasOverflow);
    this.previous.disabled = !hasOverflow || current <= 3;
    this.next.disabled = !hasOverflow || current >= maximum - 3;
  }
}

if (!customElements.get('rare-category-rail')) {
  customElements.define('rare-category-rail', RareCategoryRail);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setupRareReveals());
} else {
  setupRareReveals();
}

document.addEventListener('shopify:section:load', (event) => setupRareReveals(event.target));
